import { analyticsDashboardUrl } from 'js/profiles/autotest/destinations';
import { currentUser } from 'js/utils/user';

/**
 * The VIEWER's own analytics readers page, or null when there is no logged-in
 * member to have one.
 *
 * Deliberately the viewer's rather than the viewed profile's. Both callers —
 * the Find Readers CTA and the linked view count — only run for someone looking
 * at their own work, so today the two coincide; but the components are meant to
 * be dropped beside any work, and on somebody else's profile the viewed user
 * would be the wrong person entirely. That is a silent wrong-destination bug
 * rather than a visible one, so the safe reading is hard-coded here instead of
 * left to each call site.
 */
export const readersPageUrl = (): string | null => {
  const pageName = currentUser?.page_name;
  if (!pageName) return null;

  return analyticsDashboardUrl(pageName, 'readers', currentUser?.domain_name);
};

export default readersPageUrl;
